<template>
  <div v-if="true">
    <modal
      name="example"
      :adaptive="true"
      :scrollable="true"
      @before-open="setConstraint"
      height="auto"
      :click-to-close="false"
    >
      <div class="p-grid paddedCol">
        <div class="p-col-12">
          <div class="modal-header">
            <h2 class="title is-3" v-if="existing">{{ $t("edit-travel-constraints") }}</h2>
            <h2 class="title is-3" v-else>{{ $t("add-travel-constraints") }}</h2>
          </div>
          <p>
            <i> {{ $t("enter-0-to-remove-a-constraint") }} </i>
          </p>
        </div>

        <div class="p-col-6">
          <div>
            <p class="title is-5">{{ $t("weekday-constraints") }}</p>
          </div>
          <div>
            <p class="p-my-2">{{ $t("max-distance-from-home-venue") }}</p>
            <InputNumber
              id="horizontal"
              v-model="constraint.max_distance_weekday_home"
              showButtons
              buttonLayout="horizontal"
              :step="1"
              :min="0"
              decrementButtonClass="dsButton"
              incrementButtonClass="dsButton"
              incrementButtonIcon="pi pi-plus"
              decrementButtonIcon="pi pi-minus"
            />
          </div>
          <div>
            <p class="p-my-2">{{ $t("max-time-from-home-venue") }}</p>
            <InputNumber
              id="horizontal"
              v-model="constraint.max_time_weekday_home"
              showButtons
              buttonLayout="horizontal"
              :step="1"
              :min="0"
              decrementButtonClass="dsButton"
              incrementButtonClass="dsButton"
              incrementButtonIcon="pi pi-plus"
              decrementButtonIcon="pi pi-minus"
            />
          </div>
          <div>
            <p class="p-my-2">{{ $t("max-distance-from-last-game") }}</p>
            <InputNumber
              id="horizontal"
              v-model="constraint.max_distance_weekday_last"
              showButtons
              buttonLayout="horizontal"
              :step="1"
              :min="0"
              decrementButtonClass="dsButton"
              incrementButtonClass="dsButton"
              incrementButtonIcon="pi pi-plus"
              decrementButtonIcon="pi pi-minus"
            />
          </div>
          <div>
            <p class="p-my-2">{{ $t("max-time-from-last-game") }}</p>
            <InputNumber
              id="horizontal"
              v-model="constraint.max_time_weekday_last"
              showButtons
              buttonLayout="horizontal"
              :step="1"
              :min="0"
              decrementButtonClass="dsButton"
              incrementButtonClass="dsButton"
              incrementButtonIcon="pi pi-plus"
              decrementButtonIcon="pi pi-minus"
            />
          </div>
        </div>

        <!-- WEEKEND -->
        <div class="p-col-6">
          <div>
            <p class="title is-5">{{ $t("weekend-constraints") }}</p>
          </div>
          <div>
            <p class="p-my-2">{{ $t("max-distance-from-home-venue") }}</p>
            <InputNumber
              id="horizontal"
              v-model="constraint.max_distance_weekend_home"
              showButtons
              buttonLayout="horizontal"
              :step="1"
              :min="0"
              decrementButtonClass="dsButton"
              incrementButtonClass="dsButton"
              incrementButtonIcon="pi pi-plus"
              decrementButtonIcon="pi pi-minus"
            />
          </div>
          <div>
            <p class="p-my-2">{{ $t("max-time-from-home-venue") }}</p>
            <InputNumber
              id="horizontal"
              v-model="constraint.max_time_weekend_home"
              showButtons
              buttonLayout="horizontal"
              :step="1"
              :min="0"
              decrementButtonClass="dsButton"
              incrementButtonClass="dsButton"
              incrementButtonIcon="pi pi-plus"
              decrementButtonIcon="pi pi-minus"
            />
          </div>
          <div>
            <p class="p-my-2">{{ $t("max-distance-from-last-game") }}</p>
            <InputNumber
              id="horizontal"
              v-model="constraint.max_distance_weekend_last"
              showButtons
              buttonLayout="horizontal"
              :step="1"
              :min="0"
              decrementButtonClass="dsButton"
              incrementButtonClass="dsButton"
              incrementButtonIcon="pi pi-plus"
              decrementButtonIcon="pi pi-minus"
            />
          </div>
          <div>
            <p class="p-my-2">{{ $t("max-time-from-last-game") }}</p>
            <InputNumber
              id="horizontal"
              v-model="constraint.max_time_weekend_last"
              showButtons
              buttonLayout="horizontal"
              :step="1"
              :min="0"
              decrementButtonClass="dsButton"
              incrementButtonClass="dsButton"
              incrementButtonIcon="pi pi-plus"
              decrementButtonIcon="pi pi-minus"
            />
          </div>
        </div>
        <div class="p-col-12 p-text-center p-mt-3">
          <div>
            <b-checkbox v-model="applyAll" name="Apply to All Teams">{{
              $t("apply-these-constraints-to-all-teams-in-division")
            }}</b-checkbox>
            <br /><br />
          </div>
          <button class="button is-large" @click="saveContraints">{{ $t("Button.save") }}</button>
        </div>
      </div>
    </modal>
  </div>
  <div v-else-if="false">
    <modal
      name="example"
      :adaptive="true"
      :scrollable="true"
      @before-open="setConstraint"
      height="auto"
      :click-to-close="false"
    >
      <div class="modal-wrapper">
        <div class="modal-header">
          <h2 class="title is-3" v-if="existing">{{ $t("edit-travel-constraints") }}</h2>
          <h2 class="title is-3" v-else>{{ $t("add-travel-constraints") }}</h2>
        </div>
        <div class="p-mb-3 italic">{{ $t("enter-0-to-remove-a-constraint") }}</div>
        <div class="modal-content p-grid">
          <div class="p-grid">
            <div class="p-col-6">
              <p class="title is-5">{{ $t("weekday-constraints") }}</p>
              <div class="p-md-3">
                <p>{{ $t("max-distance-from-home-venue") }}</p>
                <InputNumber
                  id="horizontal"
                  v-model="constraint.max_distance_weekday_home"
                  showButtons
                  buttonLayout="horizontal"
                  :step="1"
                  :min="0"
                  decrementButtonClass="dsButton"
                  incrementButtonClass="dsButton"
                  incrementButtonIcon="pi pi-plus"
                  decrementButtonIcon="pi pi-minus"
                />
              </div>
              <b-field :label="$t('max-distance-from-home-venue')">
                <b-numberinput min="0" v-model="constraint.max_distance_weekday_home"></b-numberinput>
              </b-field>
              <b-field :label="$t('max-time-from-home-venue')">
                <b-numberinput min="0" step="30" v-model="constraint.max_time_weekday_home"></b-numberinput>
              </b-field>
              <b-field :label="$t('max-distance-from-last-game')">
                <b-numberinput min="0" v-model="constraint.max_distance_weekday_last"></b-numberinput>
              </b-field>
              <b-field :label="$t('max-time-from-last-game')">
                <b-numberinput min="0" step="30" v-model="constraint.max_time_weekday_last"></b-numberinput>
              </b-field>
            </div>
            <div class="p-col-6">
              <p class="title is-5">$t('weekend-constraints')</p>
              <b-field :label="$t('max-distance-from-home-venue')">
                <b-numberinput min="0" v-model="constraint.max_distance_weekend_home"></b-numberinput>
              </b-field>
              <b-field :label="$t('max-time-from-home-venue')">
                <b-numberinput min="0" step="30" v-model="constraint.max_time_weekend_home"></b-numberinput>
              </b-field>
              <b-field :label="$t('max-distance-from-last-game')">
                <b-numberinput min="0" v-model="constraint.max_distance_weekend_last"></b-numberinput>
              </b-field>
              <b-field :label="$t('max-time-from-last-game')">
                <b-numberinput min="0" step="30" v-model="constraint.max_time_weekend_last"></b-numberinput>
              </b-field>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-actions">
        <h1>HEY</h1>
        <div>
          <b-checkbox v-model="applyAll" name="Apply to All Teams">{{
            $t("apply-these-constraints-to-all-teams-in-division")
          }}</b-checkbox>
          <br /><br />
        </div>
        <button class="button is-large" @click="saveContraints">$t('Button.save')</button>
      </div>
    </modal>
  </div>
</template>

<script>
import api from "@/api";

export default {
  components: {},
  props: ["input", "team"],
  data() {
    return {
      applyAll: false,
      constraint: {
        max_distance_weekday_home: 0,
        max_distance_weekend_home: 0,
        max_distance_weekday_last: 0,
        max_distance_weekend_last: 0,
        max_time_weekday_home: 0,
        max_time_weekend_home: 0,
        max_time_weekday_last: 0,
        max_time_weekend_last: 0,
      },
    };
  },
  computed: {
    existing() {
      return !!this.constraint.id;
    },
  },
  methods: {
    setConstraint() {
      this.constraint = this.input ? JSON.parse(JSON.stringify(this.input)) : this.constraint;
    },
    saveContraints() {
      console.log("Save Constraints");
      if (this.constraint.id) {
        this.updateConstraints();
      } else {
        this.createConstraints();
      }
    },
    updateConstraints() {
      console.log("UPDATE constraint " + this.constraint.id);
      api
        .updateTravelConstraint(this.constraint.id, this.constraint, this.applyAll)
        .then(response => {
          this.$emit("refresh");
          this.makeToast("success", this.$t("Toast.travel-constraints-updated"));
          this.$modal.hide("example");
        })
        .catch(error => {
          this.errors = error.response.data.errors;
        });
    },
    createConstraints() {
      console.log("CREATE constraint ");
      api
        .createTeamTravelConstraint(this.team.id, this.constraint, this.applyAll)
        .then(response => {
          this.$emit("refresh");
          this.makeToast("success", this.$t("Toast.travel-constraints-updated"));
          this.$modal.hide("example");
        })
        .catch(error => {
          this.errors = error.response.data.errors;
        });
    },
    removeConstraints() {
      console.log("REMOVE constraint " + this.constraint.id);
    },
  },
};
</script>

<style scoped lang="scss">
.label {
  font-weight: normal !important;
}
</style>
